import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function StagedStatusBadge({ stagedStatus }) {
  return stagedStatus ? (
    <Box
      display="inline-block"
      bgcolor="#D5F5D5"
      px={1}
      py={0.5}
      borderRadius={1}
      textAlign="center"
    >
      <Typography fontWeight="500">Staged</Typography>
    </Box>
  ) : (
    <Box
      display="inline-block"
      bgcolor="#F8D7DA"
      px={1}
      py={0.5}
      borderRadius={1}
      textAlign="center"
    >
      <Typography fontWeight="500">Not Staged</Typography>
    </Box>
  );
}
